import React from "react"
import { MainCP } from "../../Components/recuerdo-guiado-marcas-teleton/MainCP"

const ViewRecuerdoGuiadoMarcasTeleton: React.FC = () => <MainCP/>

export default ViewRecuerdoGuiadoMarcasTeleton